<template>
    <OutfitSwipe
        :visitProduct="true"
        :outfitCurrent="outfitCurrent"
        :noOutfitsForTheseFilters="noOutfitsForTheseFilters"
        :swapProductCb="(product) => $emit('swap-product', product)"
        :saveOutfit="saveOutfit"
        :rejectOutfit="rejectOutfit"
    />
</template>

<script>
    import Mixins from '../../mixins/mixins';
    import {mapGetters} from 'vuex';
    import OutfitSwipe from './outfit-swipe.vue';

    export default {
        mixins: [Mixins],
        components: {OutfitSwipe},
        data() {
            return {
                hideUndoRejectInterval: 3000,
            };
        },
        computed: {
            outfit() {
                return thisoutfitCurrent || {};
            },
            ...mapGetters({
                outfitCurrent: 'generatedOutfits/generatedOutfitCurrent',
                noOutfitsForTheseFilters: "generatedOutfits/getNoOutfits",
            })
        },
        methods: {
            generateOutfit(copyUndoOutfit = false) {
                return this.$store.dispatch('generatedOutfits/generateNewOutfit', copyUndoOutfit)
            },
            saveOutfit() {
                let outfit = this.outfitCurrent;

                this.$store.commit('generatedOutfits/setUndoOutfit', null);

                return this.$store.dispatch("savedOutfits/scoreOutfit", {
                    score: 1,
                    outfit
                }).finally(this.generateOutfit);
            },
            rejectOutfit() {
                let outfit = this.outfitCurrent;
                

                return this.$store.dispatch("savedOutfits/scoreOutfit", {
                    score: -1,
                    outfit
                }).finally(() => {
                    this.generateOutfit(true)
                    setTimeout(() => {
                        this.$store.commit('generatedOutfits/setUndoOutfit', null);
                    }, this.hideUndoRejectInterval);
                });
            }
        },
        created() {
            this.$store.commit('generatedOutfits/setUndoOutfit', null);
        },
        destroyed() {
            this.$store.commit('generatedOutfits/setUndoOutfit', null);
        }
    }
</script>
